<template lang="html">
  <div class="choose-coupon">
    <coupon v-on:selectCoupon="getCoupon"></coupon>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import coupon from '../chooseCoupon'

export default {
  components: {
    coupon
  },
  // computed: {
  //     ...mapState(['selectedWorker']),
  // },
  methods: {
    getCoupon(item) {
      this.$store.commit('setSelectedCoupon', item)
      if (this.$route.query.action) {
        this.$router.go(-1)
      } else {
        this.$store.commit('hideActionSheet', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
